import { FullTextSearchDataStore } from './fullTextSearchDataStore';
import { UserGroupDataStore } from './userGroupDataStore';
import { UserGroupsDataStoreFactory } from 'sharebase/dataStores/userGroupsDataStore';
import {
	HelpBlurbDataStore,
	NullHelpBlurbDataStore
} from 'sharebase/dataStores/help-blurb-datastore'
import UserDataStore from'./userDataStore';
import UsersDataStore from'./usersDataStore';
import { StaticToggleService } from 'util/services';
import { IStorageAccessor } from 'util/domain';
import { AclDatastore } from './aclDatastore';
import { UserHistoryDataStore } from './userHistoryDataStore';

export const datastoreModule = angular
	.module('sharebase.datastore', [
		'sharebase.services'
	])
	.service('sbUserDataStore', UserDataStore)
	.service('sbUsersDataStore', UsersDataStore)
	.service('sbUserGroupDataStore', UserGroupDataStore)
	.factory('sbUserGroupsDataStore', UserGroupsDataStoreFactory)
	.factory('sbHelpBlurbDataStore',HelpBlurbDataStoreFactory)
	.factory('sbAclDatastore', AclDatastore)
	.factory('sbUserHistoryDataStore', UserHistoryDataStore)
	.service('sbFullTextDataStore', FullTextSearchDataStore);

function HelpBlurbDataStoreFactory(
	staticToggleService:StaticToggleService,
	localStorageService:IStorageAccessor
){
	if(staticToggleService.isEnabled('help-blurbs')) {
		return new HelpBlurbDataStore(localStorageService);
	}
	else {
		return new NullHelpBlurbDataStore();
	}
}

HelpBlurbDataStoreFactory.$inject = [
	'staticToggleService',
	'localStorageService',
];

export * from './aclDatastore';


// WEBPACK FOOTER //
// ./src/sharebase/dataStores/index.ts